import React, { Component } from 'react';
import { Container, Row, Col, Form, Table, Card, Button } from 'react-bootstrap';
import { DatePicker } from 'antd';
import moment from 'moment';
import Side from './Sidebar';
import Top from './Topbar';
import C from '../lib/Config';
import swal from 'sweetalert';
import { FaTimesCircle } from 'react-icons/fa';
import '../App.css';

export default class PlanCompletion extends Component {

    exportToPDF = () => {
        const { filteredData } = this.state;
        const printWindow = window.open('', '_blank');
        const style = `
            <style>
                table { 
                    border-collapse: collapse; 
                    width: 100%;
                    font-size: 8px; 
                }
                th, td { 
                    border: 1px solid #ddd; 
                    padding: 4px; 
                    text-align: left;
                    word-wrap: break-word;
                    max-width: 150px;
                }
                th { 
                    background-color: #6c757d; 
                    color: white; 
                }
                @media print {
                    @page {
                        size: landscape;
                        margin: 10mm;
                    }
                }
            </style>
        `;
    
        const currentDate = new Date().toLocaleString();
        const headerRow = Object.values(this.getHeaderConfig()).map(config => 
            `<th>${config.label}</th>`
        ).join('');
    
        const rows = filteredData.flatMap(patient => 
            patient.treatmentPlans.map(plan => `
                <tr>
                    <td>${patient.patientName}</td>
                    <td>${patient.mrNo}</td>
                    <td>${patient.address}</td>
                    <td>${patient.phone}</td>
                    <td>${plan.planNo}</td>
                    <td>${plan.planDate}</td>
                    <td>${plan.totalCycles}</td>
                    <td>${plan.completedCycles}</td>
                    <td>${plan.chemoDetails && plan.chemoDetails.length > 0 ? 
                        plan.chemoDetails.map(chemo => 
                            `Cycle ${chemo.chemoCycleNumber}: ${moment(chemo.chemoDate).format('DD-MM-YYYY')}`
                        ).join('<br/>') : 'N/A'}
                    </td>
                    <td>${plan.chemotherapyName}</td>
                    ${this.state.isRestrictedFieldsVisible ? `
                        <td>${patient.category}</td>
                        <td>${patient.company}</td>
                        <td>${patient.tariff}</td>
                        <td>${patient.payType}</td>
                    ` : ''}
                    <td>${patient.status}</td>
                </tr>
            `).join('')
        );
    
        const html = `
            <html>
                <head>
                    <title>Chemo Entry Report</title>
                    ${style}
                </head>
                <body>
                    <h2>Chemo Entry Report</h2>
                    <p>Generated on: ${currentDate}</p>
                    <table>
                        <thead>
                            <tr>${headerRow}</tr>
                        </thead>
                        <tbody>${rows}</tbody>
                    </table>
                </body>
            </html>
        `;
    
        printWindow.document.write(html);
        printWindow.document.close();
        setTimeout(() => {
            printWindow.print();
        }, 500);
    };
    
    exportToExcel = () => {
        const { filteredData } = this.state;
        let csvContent = "data:text/csv;charset=utf-8,";
        
        // Headers
        const headers = Object.values(this.getHeaderConfig()).map(config => config.label);
        csvContent += headers.join(',') + '\n';
        
        // Data
        filteredData.forEach(patient => {
            patient.treatmentPlans.forEach(plan => {
                const row = [
                    patient.patientName,
                    patient.mrNo,
                    this.escapeCSV(patient.address),
                    this.escapeCSV(`${patient.phone}`),
                    plan.planNo,
                    plan.planDate,
                    plan.totalCycles,
                    plan.completedCycles,
                    // plan.details || 'N/A',
                    this.escapeCSV(plan.chemotherapyName),
                    
                ];
    
                if (this.state.isRestrictedFieldsVisible) {
                    row.push(
                        patient.category,
                        patient.company,
                        patient.tariff,
                        patient.payType
                    );
                }
                row.push(patient.status);
                
                csvContent += row.join(',') + '\n';
            });
        });
    
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement('a');
        link.setAttribute('href', encodedUri);
        link.setAttribute('download', 'ChemoPlanReport.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    
    formatStagingDetails = (staging) => {
        if (!staging) return 'N/A';
        return `T:${staging.tStage} N:${staging.nStage} M:${staging.mStage}`;
    };
    
    escapeCSV = (str) => {
        if (!str) return '';
        return `"${str.replace(/"/g, '""')}"`;
    };
    
    getHeaderConfig = () => ({
        patientName: { label: 'Patient Name' },
        mrNo: { label: 'MR No' },
        address: { label: 'Address' },
        contactDetails: { label: 'Contact Details' },
        planNo: { label: 'Plan No' },
        planDate: { label: 'Plan Date' },
        totalCycles: { label: 'Planned Cycles' },
        completedCycles: { label: 'Completed Cycles' },
        // details: { label: 'Details' },
        chemoName: { label: 'Chemotherapy Name' },
        ...(this.state.isRestrictedFieldsVisible && {
            category: { label: 'Category' },
            company: { label: 'Company' },
            tariff: { label: 'Tarrif' },
            payType: { label: 'Pay Type' }
        }),
        status: { label: 'Status' }
    });

    constructor(props) {
        super(props);
        this.state = {
          reportData: [], // Full dataset
          filteredData: [], // Data for display
          isRestrictedFieldsVisible: false, // Controls restricted fields visibility
          userId: localStorage.getItem('userId'),
          instituteArr: [],
          selectedInstitute: '',
          specificDate: null,
          planDate: null,
          tariff: '',
          patientName: '',
          protocolName:'',
          doctorName: '',
          loading: false,
          error: null,
          allChemoDates: null,
          tableVisible: false, // Controls table visibility on load
          tariffOptions: ['Select Tariff',
        'Cash Patient',
        'Insurance',
        'MJPJAY',
        'AB_ARKA',
        'AASA',
        'MDDSS',
        'YESIC',
        'ECHS',
        'MPKAY',
        'Trial (CRC)',
        'KCC Employee',
        'Insurance GIPSA PPN',
        'Private OPD',
        'Konkan Railway',
        'Airport',
        'KCC Package'
    ]
        };
      }

    componentDidMount() {
        this.checkUserAccess();
        this.getAllInstitute();
    }

    checkUserAccess = () => {
        const userId = this.state.userId;
        if (userId === '90' || userId === '74') {
            this.setState({ isRestrictedFieldsVisible: true });
        }
    }

    getAllInstitute = () => {
        const userId = this.state.userId;
        return fetch(`${C.getUrl()}/institute/getAllInstituteByUserId/${userId}`)
            .then(res => res.json())
            .then(res => {
                const arr = res.map(d => ({
                    id: d.instituteId,
                    name: d.instituteName
                }));
                this.setState({ 
                    instituteArr: arr,
                    selectedInstitute: arr.length === 1 ? arr[0].id : ''
                }, () => {
                    if (arr.length === 1) {
                        this.fetchReportData();
                    }
                });
            })
            .catch(err => {
                swal({
                    title: "Error!",
                    text: "Error fetching institutes: " + err,
                    icon: "error",
                    buttons: false,
                    timer: 2000,
                });
            });
    }
    handleSearch = () => {
        const { patientName, protocolName, planDate, filteredData } = this.state;
    
        if (!patientName && !protocolName && !planDate) {
            swal("Warning!", "Please enter at least one filter criteria to search.", "warning");
            return;
        }
    
        // Check if we're filtering existing results or doing a new search
        if (filteredData.length > 0) {
            // Filter existing results
            this.filterExistingResults();
        } else {
            // New search
            this.setState({ filteredData: [] }, () => {
                this.fetchReportData();
            });
        }
        
        this.setState({ tableVisible: true });
    };
    
    filterExistingResults = () => {
        const { filteredData, planDate, patientName, protocolName } = this.state;
        
        let newFilteredData = [...filteredData];

        // Apply date filter if present
        if (planDate) {
            const searchDate = moment(planDate).format('DD-MM-YYYY');
            newFilteredData = newFilteredData.map(patient => ({
                ...patient,
                treatmentPlans: patient.treatmentPlans.filter(plan => 
                    plan.planDate === searchDate
                )
            })).filter(patient => patient.treatmentPlans.length > 0);
        }

        // Apply patient name filter if present
        if (patientName && patientName.trim() !== '') {
            newFilteredData = newFilteredData.filter(patient =>
                patient.patientName.toLowerCase().includes(patientName.trim().toLowerCase())
            );
        }

        // Apply protocol name filter if present
        if (protocolName && protocolName.trim() !== '') {
            newFilteredData = newFilteredData.map(patient => ({
                ...patient,
                treatmentPlans: patient.treatmentPlans.filter(plan =>
                    plan.protocolName &&
                    plan.protocolName.toLowerCase().includes(protocolName.trim().toLowerCase())
                )
            })).filter(patient => patient.treatmentPlans.length > 0);
        }

        this.setState({ filteredData: newFilteredData });
    };

    fetchReportData = async () => {
        try {
            const { selectedInstitute, planDate, patientName, protocolName } = this.state;
     
            if (!selectedInstitute && this.state.instituteArr.length > 1) {
                return;
            }
     
            this.setState({ loading: true });
     
            let url = `${C.getUrl()}/patientData/allfilters?instituteId=${selectedInstitute}`;
     
            // Add all active filters to the URL
            if (patientName && patientName.trim() !== '') {
                url += `&patientName=${encodeURIComponent(patientName.trim())}`;
            }
            
            if (protocolName && protocolName.trim() !== '') {
                url += `&protocolName=${encodeURIComponent(protocolName.trim())}`;
            }

            if (planDate) {
                const formattedDate = moment(planDate).format('YYYY-MM-DD');
                url += `&planDate=${formattedDate}`;
            }
     
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
     
            const data = await response.json();
            let processedData = this.processReportData(data);
    
            // Apply client-side filtering
            let filteredResults = processedData;

            // Apply each filter in sequence
            if (planDate) {
                const searchDate = moment(planDate).format('DD-MM-YYYY');
                filteredResults = filteredResults.filter(patient => 
                    patient.treatmentPlans.some(plan => 
                        plan.planDate === searchDate
                    )
                ).map(patient => ({
                    ...patient,
                    treatmentPlans: patient.treatmentPlans.filter(plan =>
                        plan.planDate === searchDate
                    )
                }));
            }

            if (patientName && patientName.trim() !== '') {
                filteredResults = filteredResults.filter(patient =>
                    patient.patientName.toLowerCase().includes(patientName.trim().toLowerCase())
                );
            }

            if (protocolName && protocolName.trim() !== '') {
                filteredResults = filteredResults.map(patient => ({
                    ...patient,
                    treatmentPlans: patient.treatmentPlans.filter(plan =>
                        plan.protocolName &&
                        plan.protocolName.toLowerCase().includes(protocolName.trim().toLowerCase())
                    )
                })).filter(patient => patient.treatmentPlans.length > 0);
            }
     
            this.setState({
                reportData: processedData,
                filteredData: filteredResults,
                loading: false
            });
     
        } catch (error) {
            console.error('Error fetching report data:', error);
            this.setState({
                error: error.message,
                loading: false
            });
            swal({
                title: "Error!",
                text: error.message,
                icon: "error",
                buttons: false,
                timer: 2000
            });
        }
    };

     processReportData = (data) => {
        return data.map((item) => {
            // Calculate start and end dates from chemo cycles
            let startDate = 'N/A';
            let endDate = 'N/A';
            
            if (item.treatmentPlans && item.treatmentPlans[0] && item.treatmentPlans[0].chemoDetails) {
                const chemoDates = item.treatmentPlans[0].chemoDetails
                    .map(detail => new Date(detail.chemoDate))
                    .sort((a, b) => a - b);
                
                if (chemoDates.length > 0) {
                    startDate = moment(chemoDates[0]).format('DD-MM-YYYY');
                    endDate = startDate; // End Date is now the same as Start Date
                }
            }
    
            return {
                patientId: item.patientId,
                patientName: `${item.firstName} ${item.lastName}`,
                gender: item.genderId === 1 ? 'Male' : 'Female',
                phone: item.phoneNumber1,
                address: `${item.addressLine1 || ''} ${item.addressLine2 || ''}`.trim(),
                mrNo: item.mrNo !== '(NULL)' ? item.mrNo : 'N/A',
                category: item.category || 'N/A',
                company: item.company || 'N/A',
                tariff: item.tariff || 'N/A',
                payType: item.payType || 'N/A',
                status: item.status || 'N/A',
                treatmentPlans: this.processPlans(item.treatmentPlans),
                
            };
        });
    };

    processPlans = (plans) => {
        if (!plans || !Array.isArray(plans)) return [];
        const completedCycles = this.calculateCompletedCycles(plans);
        return plans.map(plan => ({
            completedCycles: completedCycles,
            protocolName: plan.protocolName || 'N/A',
            planNo: plan.planNo || 'N/A',
            planDate: plan.planDate ? moment(plan.planDate).format('DD-MM-YYYY') : 'N/A',
            totalCycles: plan.totalCycles || 'N/A',
            nameOfConsultant: plan.nameOfConsultant || 'N/A',
            chemotherapyName: plan.protocolName || 'N/A',
            chemoDetails: plan.chemoDetails || []
        }));
    }

    calculateCompletedCycles = (plans) => {
        if (!plans || !Array.isArray(plans)) return 'N/A';
    
        const today = moment();
        let totalCompletedCycles = 0;
    
        // Sort plans by plan date to ensure we calculate cycles chronologically
        const sortedPlans = plans.sort((a, b) => 
            moment(a.planDate).diff(moment(b.planDate))
        );
    
        // Iterate through sorted plans
        sortedPlans.forEach(plan => {
            // Skip if plan date is in the future
            if (moment(plan.planDate).isAfter(today)) return;
    
            // If chemo details exist, use them to calculate completed cycles
            if (plan.chemoDetails && plan.chemoDetails.length > 0) {
                const completedChemoDates = plan.chemoDetails.filter(detail => 
                    moment(detail.chemoDate).isSameOrBefore(today)
                );
                
                // Add completed cycles for this plan
                totalCompletedCycles += completedChemoDates.length;
            } else {
                // If no chemo details, estimate based on plan date and total cycles
                const cycleDuration = 21; // Assuming 21 days per cycle
                const daysSincePlanDate = today.diff(moment(plan.planDate), 'days');
                const estimatedCompletedCycles = Math.floor(daysSincePlanDate / cycleDuration);
    
                // Ensure we don't exceed total planned cycles
                const planCompletedCycles = Math.min(
                    estimatedCompletedCycles, 
                    parseInt(plan.totalCycles || 0)
                );
    
                totalCompletedCycles += planCompletedCycles;
            }
        });
    
        // Ensure total completed cycles doesn't exceed total planned cycles
        const maxPossibleCycles = sortedPlans.reduce((sum, plan) => 
            sum + parseInt(plan.totalCycles || 0), 0
        );
    
        return Math.min(totalCompletedCycles, maxPossibleCycles);
    };

    processStaging = (staging) => {
        if (!staging || !Array.isArray(staging)) return [];
        return staging.map(stage => ({
            tStage: stage.tStage || 'N/A',
            nStage: stage.nStage || 'N/A',
            mStage: stage.mStage || 'N/A'
        }));
    }

    handleDateChange = (date) => {
        this.setState({ planDate: date });
    };

    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };
    
 
    clearFilters = () => {
        this.setState({
            planDate: null,
            patientName: '',
            protocolName: '',
            filteredData: [],
            tableVisible: false,
        });
    };

    render() {
        const { 
            filteredData,
            loading,
            error,
            tableVisible,
            patientName,
            protocolName,
        } = this.state;
        
        return (
            <div className="d-flex" id="wrapper">
                <Side />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Top />
                        <Container fluid>
                            <div className="mb-2">
                            <h6 className="text-success" style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '20px' }}>
                            Treatment Plan Completion Status List
                            </h6>
                                <div className="float-right mb-2">
                                    <Button variant="outline-success" className="mr-2" onClick={this.exportToExcel}>
                                        Export to Excel
                                    </Button>
                                    <Button variant="outline-danger" onClick={this.exportToPDF}>
                                        Export to PDF
                                    </Button>
                                </div>
                            </div>

                            <Row className="mb-3 align-items-end g-0">
                            <Col md={2}>
                                <Form.Group>
                                    <Form.Label>Patient Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Search by patient name"
                                        name="patientName"
                                        value={this.state.patientName}
                                        onChange={this.handleInputChange}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={2}>
                                <Form.Group>
                                    <Form.Label>Protocol Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter Protocol name"
                                        name="protocolName"
                                        value={this.state.protocolName}
                                        onChange={this.handleInputChange}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={2}>
                                <Form.Group>
                                    <Form.Label>Plan Date</Form.Label>
                                    <DatePicker
                                        onChange={this.handleDateChange}
                                        format="DD-MM-YYYY"
                                        className="form-control"
                                        placeholder="Select Plan Date"
                                        value={this.state.planDate}
                                    />
                                </Form.Group>
                            </Col>
                                
                            <Col md="auto" className="d-flex justify-content-start">
                                <Button 
                                    variant="secondary" 
                                    onClick={this.handleSearch} 
                                    className="mb-3 px-4"
                                >
                                    Search
                                </Button>
                            </Col>
                            <Col md="auto" className="d-flex justify-content-start">
                                <Button 
                                    variant="secondary" 
                                    onClick={this.clearFilters}
                                    className="mb-3 px-4"
                                >
                                    Clear Filters
                                </Button>
                            </Col>
                            </Row>

                            <div className="table-responsive" style={{ maxHeight: '70vh' }}>
  {tableVisible && (
    <Table striped bordered hover className="mb-0">
      <thead style={{ position: 'sticky', top: 0, backgroundColor: '#6c757d', color: 'white' }}>
        <tr>
          <th style={{ minWidth: '150px' }}>Patient Name</th>
          <th style={{ minWidth: '100px' }}>MR No</th>
          <th style={{ minWidth: '200px' }}>Address</th>
          <th style={{ minWidth: '150px' }}>Contact Details</th>
          <th style={{ minWidth: '100px' }}>Plan No</th>
          <th style={{ minWidth: '120px' }}>Plan Date</th>
          <th style={{ minWidth: '100px' }}>Planned Cycles</th>
          <th style={{ minWidth: '120px' }}>Completed Cycles</th>
          <th style={{ minWidth: '200px' }}>Chemotherapy Name</th>
          <th style={{ minWidth: '120px' }}>Category</th>
          <th style={{ minWidth: '120px' }}>Company</th>
          <th style={{ minWidth: '120px' }}>Tariff</th>
          <th style={{ minWidth: '120px' }}>Pay Type</th>
          <th style={{ minWidth: '100px' }}>Status</th>
        </tr>
      </thead>
      <tbody>
        {loading ? (
          <tr>
            <td colSpan={26} className="text-center py-4">
              Loading...
            </td>
          </tr>
        ) : error ? (
          <tr>
            <td colSpan={26} className="text-center py-4 text-danger">
              {error}
            </td>
          </tr>
        ) : filteredData.length === 0 ? (
          <tr>
            <td colSpan={26} className="text-center py-4">
              No records found.
            </td>
          </tr>
        ) : (
          filteredData.map((patient) =>
            patient.treatmentPlans.flatMap((plan) =>
              plan.chemoDetails.map((chemo, chemoIndex) => (
                <tr key={`${patient.patientId}-${plan.planNo}-${chemoIndex}`}>
                  {/* Display all patient and plan details for each row */}
                  <td>{patient.patientName}</td>
                  <td>{patient.mrNo}</td>
                  <td>{patient.address}</td>
                  <td>
                    {patient.phone}
                  </td>
                  <td>{plan.planNo}</td>
                  <td>{plan.planDate}</td>
                  <td>{plan.totalCycles}</td>
                  <td>{plan.completedCycles}</td>
                  <td>{plan.chemotherapyName}</td>
                  <td>{patient.category}</td>
                  <td>{patient.company}</td>
                  <td>{patient.tariff}</td>
                  <td>{patient.payType}</td>
                  <td>{patient.status}</td>
                </tr>
              ))
            )
          )
        )}
      </tbody>
    </Table>
  )}
</div>




                        </Container>
                    </div>
                </div>
            </div>
        );
    }
}